import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Logo from '../../components/Logo';
import SplashScreen from '../../components/SplashScreen';
import toast from 'react-hot-toast';
import './Auth.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { login, user } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const result = await login(email, senha);
      console.log('🔐 Login result:', result);
      
      if (result && result.success) {
        // Delay para mostrar o splash por mais tempo
        setTimeout(() => {
          const userType = result.user?.tipo || user?.tipo;
          console.log('🔐 User type:', userType);
          
          if (userType === 'entregador') {
            window.location.href = '/entregador';
          } else {
            window.location.href = '/admin/dashboard';
          }
          setLoading(false);
        }, 2000); // 2 segundos de splash
      } else {
        const errorMsg = result?.error || 'Erro ao fazer login. Verifique suas credenciais.';
        console.error('❌ Login falhou:', errorMsg);
        setError(errorMsg);
        toast.error(errorMsg);
        setLoading(false);
      }
    } catch (error) {
      console.error('❌ Erro no login:', error);
      const errorMsg = 'Erro ao conectar com o servidor. Tente novamente.';
      setError(errorMsg);
      toast.error(errorMsg);
      setLoading(false);
    }
  };

  // Mostrar splash durante o loading
  if (loading) {
    return <SplashScreen />;
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
        <Logo size="medium" />
        <p className="auth-subtitle">Entre com suas credenciais</p>

        <form onSubmit={handleSubmit}>
          {error && (
            <div className="alert alert-error" style={{ 
              padding: '12px', 
              marginBottom: '16px', 
              backgroundColor: '#fee', 
              color: '#c33', 
              borderRadius: '4px',
              fontSize: '14px'
            }}>
              {error}
            </div>
          )}
          
          <div className="form-group">
            <label className="label">Email</label>
            <input
              type="email"
              className="input"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setError(''); // Limpar erro ao digitar
              }}
              required
              placeholder="seu@email.com"
            />
          </div>

          <div className="form-group">
            <label className="label">Senha</label>
            <input
              type="password"
              className="input"
              value={senha}
              onChange={(e) => {
                setSenha(e.target.value);
                setError(''); // Limpar erro ao digitar
              }}
              required
              placeholder="••••••••"
            />
          </div>

          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Entrando...' : 'Entrar'}
          </button>
        </form>

        <p className="auth-footer">
          Não tem uma conta? <Link to="/register">Cadastre-se</Link>
        </p>
      </div>
    </div>
  );
};

export default Login;

